import React, {Fragment, useContext, useEffect, useMemo, useRef, useState} from 'react';
import {Card, CardContent, Grid} from "@mui/material";
import {WMSContext} from "../../../context/WMSContext";
import {
    getWmsItemsForPacking,
    getWmsItemToBeCancelledStatus,
    packShipmentItem,
    searchPackableItemsByOrder,
} from "../../../../../api/wms/wmsItems/wmsItems";
import SearchBar from "../../../../../components/List/components/SearchBar";
import ToggleNavigation from "../../../../../components/WMS/Mobile/Toggle/ToggleNavigation";
import Toggle from "../../../../../components/WMS/Mobile/Toggle/Toggle";
import {FormattedMessage} from "react-intl";
import WmsItemWithOrder from "../../../../../components/WMS/Mobile/WmsItemWithOrder";
import ShipmentMultiPacking from "./components/Drawers/ShipmentMultiPackingDrawer";
import ShipmentMonoPacking from "./components/Drawers/ShipmentMonoPackingDrawer";
import ScanWorkstationModal from "../Modals/ScanWorkstationModal";
import WeighShipmentModal from "../Modals/WeighShipmentModal";
import ScanShippingZoneOrTrolleyModal from "../Modals/ScanShippingZoneOrTrolleyModal";
import AlreadyAssignedWorkstation from "../Modals/AlreadyAssignedWorkstartion";
import ClickAndCollectPackingModal from "../Modals/ClickAndCollectPackingModal";
import OffChartModal from "../Modals/OffChartModal";
import {BarCodeScannerContext} from "../../../../../contexts/barCodeScannerContext";
import {patchWMSContainerMemberWithCodebar, getWMSContainerWithCodeBar} from "../../../../../api/wms/wmsContainers/wmsContainers";
import {packingStepNames} from "./packingSteps";
import DropZoneOrTrolleyDrawer from "./components/Drawers/DropZoneOrTrolleyDrawer";
import ship from "../../../../../api/shipment/ship";
import {ShippingMethods, ShippingMethodsDiscr} from "../../../../../utils/ShippingMethods";
import {
    resetCurrentPacking,
    shipmentPacked,
    assignShipmentToContainer
} from "../../../../../api/wms/shipment/shipment";
import PackingToast from "../PackingToast";
import {getWmsItemsCancellableStatus, WmsItemsStatus} from "../../../../../utils/WmsItemsStatus";
import {launchOmniScan} from "../../../../../api/wms/omiScan";
import {WMSOmniScanReturnType} from "../../../../../utils/WMSOmniScanReturnType";
import {WmsContainerType} from "../../../../../utils/WMSContainerType";
import moment from "moment";
import {getTranslation} from "../../../../../domain/helpers/translations";
import SpecialOrderDrawer from "./components/Drawers/SpecialOrder";
import {KNCarrierType} from "../../../../../utils/KuehneNagelCarrierType";
import {specialOrderShipmentIsPackInWMS} from "../../../../../api/shipment/packing";
import AlreadyInPackingModal from "../Modals/AlreadyInPackingModal";
import {LineItemStatus} from "../../../../../utils/LineItemStatus";
import PackingActionButton from "./components/PackingActionButton";
import PackingActionDrawer from "./components/Drawers/PackingActionDrawer";
import {PackingContext} from "./PackingContext";
import {list} from 'api/cancellationReason/list'
import MultiExpSessionStartModal from "../Modals/MultiExpSessionStartModal";
import BeatLoaderRegular from "../../../../../components/loaders/BeatLoaderRegular";
import {WMSOmniScanContextKeys} from "../../../../../utils/WMSOmniScanContextKeys";

function PackingOrderList() {
    const {currentInventory, currentOrganization, currentMember, preferredPrinter, setPreferredPrinter, preferredPackingStation, setPreferredPackingStation} = useContext(WMSContext)
    const {scannedString, resetScannedString, setEnableScan} = useContext(BarCodeScannerContext)

    const [packingStep, setPackingStep] = useState({
        selectedShipment: {},
        stepName: packingStepNames.PEEK,
    })

    const [openProductProblemDrawer, setOpenProductProblemDrawer] = useState({
        isOpen: false,
        product: null,
        handleProductCancelled: () => {}
    })

    const [searchString, setSearchString] = useState("")
    const [loading, setLoading] = useState(true)
    const [selectedOrScannedContainer, setSelectedOrScannedContainer] = useState()

    const [currentWorkstation, setCurrentWorkstation] = useState()
    const [packingStationComputerId, setPackingStationComputerId] = useState()
    const [alreadyTakenPackingStationContainer, setAlreadyTakenPackingStationContainer] = useState()
    const [cancellationReasons, setCancellationReasons] = useState([]);
    const [packingLoading, setPackingLoading] = useState(true)
    const [isMultiSessionPacking, setIsMultiSessionPacking] = useState(false)
    const [isPartialExpedition, setIsPartialExpedition] = useState(false)
    const [toBeCancelledItem, setToBeCancelledItem] = useState({})

    // DRAWERS
    const [openShipmentMultiDrawer, setOpenShipmentMultiDrawer] = useState(false)
    const [openShipmentMonoDrawer, setOpenShipmentMonoDrawer] = useState(false)
    const [openDropZoneOrTrolleyDrawer, setOpenDropZoneOrTrolleyDrawer] = useState(false)
    const [openSpecialOrderDrawer, setOpenSpecialOrderDrawer] = useState(false)
    const [openPackingActionDrawer, setOpenPackingActionDrawer] = useState(false)

    // SHIPMENT
    const [ordersWithShipments, setOrdersWithShipments] = useState({})
    const [tempOrdersWithShipments, setTempOrdersWithShipments] = useState({})
    const [filteredOrdersWithShipments, setFilteredOrdersWithShipments] = useState({})
    const [monoShipmentCount, setMonoShipmentCount] = useState(0)
    const [multiShipmentCount, setMultiShipmentCount] = useState(0)
    const [shipmentTypeIndex, setShipmentTypeIndex] = useState(0)
    const [shipmentWeigh, setShipmentWeigh] = useState()
    const [shipmentTrackingNumber, setShipmentTrackingNumber] = useState();

    // TOAST
    const [openToast, setOpenToast] = useState(false)
    const [toastType, setToastType] = useState()
    const [toastIsTop, setToastIsTop] = useState(false)

    // MODALS
    const [openBeginPackingModal, setOpenBeginPackingModal] = useState(false)
    const [openScanWorkstationModal, setOpenScanWorkstationModal] = useState(false)
    const [openWeighShipmentModal, setOpenWeighShipmentModal] = useState(false)
    const [openScanShippingZoneOrTrolleyModal, setOpenScanShippingZoneOrTrolleyModal] = useState(false)
    const [openAlreadyAssignedWorkstationModal, setOpenAlreadyAssignedWorkstationModal] = useState(false)
    const [openClickAndCollectPackingModal, setOpenClickAndCollectPackingModal] = useState(false)
    const [openOffChartModal, setOpenOffChartModal] = useState(false)
    const [openAlreadyInPackingModal, setOpenAlreadyInPackingModal] = useState(false)
    const [openMultiExpSessionStartModal, setOpenMultiExpSessionStartModal] = useState(false)
    const [openToBeCancelledModal, setOpenToBeCancelledModal] = useState(false)

    const [isSearchingRemote, setIsSearchingRemote] = useState(false)

    const multiExpSessionOrderIndex = useRef(0);
    const multiExpSessionShipmentIndex = useRef(0);
    const shipmentSplitNewShipment = useRef(null)
    const searchDebounceRef = useRef(null)

    const monoOrdersWithShipments = useMemo(() => partitionByShipmentType(), [ordersWithShipments])
    const multiOrdersWithShipments = useMemo(() => partitionByShipmentType(true), [ordersWithShipments])

    const handlePackingStart = () => {
        getWmsItemsForPacking(currentInventory).then((response) => {
            let ordersAndShipments = {}
            for (let item of response) {
                const tempOrder = item.lineItem.currentShipment.order
                const tempShipment = item.lineItem.currentShipment
                const formattedShipment = getFormattedShipment(item, tempOrder, tempShipment)
                const formattedItem = getFormattedItem(item)

                if (!ordersAndShipments[tempOrder.id]) {
                    ordersAndShipments[tempOrder.id] = {}
                    ordersAndShipments[tempOrder.id].createdAt = moment(tempOrder.createdAt).format('x')
                }

                if (!ordersAndShipments[tempOrder.id].shipments) {
                    ordersAndShipments[tempOrder.id].shipments = []
                    ordersAndShipments[tempOrder.id].shipments[tempShipment.id] = formattedShipment
                }

                if (!ordersAndShipments[tempOrder.id].shipments[tempShipment.id]) {
                    ordersAndShipments[tempOrder.id].shipments[tempShipment.id] = formattedShipment
                }

                if (!ordersAndShipments[tempOrder.id].shipments[tempShipment.id].lineItems.includes(formattedItem)) {
                    ordersAndShipments[tempOrder.id].shipments[tempShipment.id].lineItems.push(formattedItem)
                }
            }

            Object.keys(ordersAndShipments).forEach((orderId) => {
                Object.keys(ordersAndShipments[orderId].shipments).forEach((shipmentId) => {
                    fixShipmentIsMulti(ordersAndShipments[orderId].shipments[shipmentId])
                })
            })

            handleMonoAndMultiCount(ordersAndShipments)
            setTempOrdersWithShipments(ordersAndShipments)
            setOrdersWithShipments(ordersAndShipments)
        }).finally(() => {
            setLoading(false)
        })
    }

    const getFormattedShipment = (item, order, shipment) => {
        let shipmentObject = {
            orderNumber: currentOrganization?.showDisplayExternalId && order.displayExternalId ? order.displayExternalId : order.externalId,
            externalDeliveryNumber: shipment.externalDeliveryNumber,
            orderId: order.id,
            shipmentId: shipment.id,
            shippingMethod: shipment.shippingMethod,
            isMulti: shipment.multi,
            trackingNumber: shipment.trackingNumber,
            lineItems: [],
            createdAt: shipment.createdAt,
            orderCreatedAt: order.createdAt,
            container: shipment.container
        }

        if (shipment.shippingMethod.ccPointCode && shipment.shippingMethod.ccPointCode !== currentInventory.code) {
            shipmentObject = {...shipmentObject, isCCInternalWMSShip: true}
        }

        return shipmentObject;
    }

    // shipment.multi only counts active (non-cancelled) LineItems (see Shipment::isMulti()): once one
    // of them is cancelled, its WMSItem can still be physically present (flagged toBeCancelled, not
    // yet put away), so the shipment keeps more WMSItems than its "multi" flag admits. Re-derive
    // isMulti from the actual WMSItem count so such shipments stay in the multi flow instead of being
    // silently downgraded to mono. Mutates in place since all callers build the shipment just before.
    const fixShipmentIsMulti = (shipment) => {
        shipment.isMulti = shipment.isMulti || 1 < shipment.lineItems.length
        return shipment
    }

    const getFormattedItem = (item) => {
        const retailerTranslation = getTranslation(item.lineItem.retailer)
        // A WMSItem merely flagged toBeCancelled (status still active, e.g. ready_to_be_packed)
        // is not yet resolved: it must keep appearing as a normal, packable item until the operator
        // processes it at scan time (handlePackItem's own toBeCancelled detection, untouched here).
        // Only a WMSItem whose status has actually transitioned to cancelled/to_be_cancelled is
        // already resolved and must appear as cancelled from the start.
        const isAlreadyCancelled = [WmsItemsStatus.CANCELED, WmsItemsStatus.TO_BE_CANCELLED].includes(item.status)
        return {
            id: item.lineItem.id,
            name: item.lineItem.name,
            pictures: item.lineItem.pictures,
            retailerName: item.lineItem.retailer.name,
            retailerIcon: retailerTranslation.logo?.contentUrl,
            ugCode: item.lineItem.variationSku,
            eanCode: item.barcode,
            options: item.lineItem.options,
            totalItem: 0,
            itemsScanned: 0,
            itemsCancelled: isAlreadyCancelled ? 1 : 0,
            isCancelled: isAlreadyCancelled,
            isPacked: false,
            weight: item.lineItem.variation?.weight,
            currentShipment: item.lineItem.currentShipment,
            wmsItem: {
                id: item.id,
                status: item.status,
                currentContainer: item.wmsContainer,
                lineItem: item.lineItem,
                places: item.places,
                barcode: item.barcode,
                toBeCancelled: item.toBeCancelled,
            }
        }
    }

    const handleMonoAndMultiCount = (ordersAndShipments) => {
        let tempMonoShipmentCount = 0
        let tempMultiShipmentCount = 0
        Object.keys(ordersAndShipments).map((orderId) => {
            Object.keys(ordersAndShipments[orderId].shipments).map((shipmentId) => {
                if (ordersAndShipments[orderId].shipments[shipmentId].isMulti) {
                    tempMultiShipmentCount++
                } else {
                    tempMonoShipmentCount++
                }
            })
        })
        setMonoShipmentCount(tempMonoShipmentCount)
        setMultiShipmentCount(tempMultiShipmentCount)
    }

    function handleFIFOSort (orders) {
        const sortedOrdersKeys = Object.keys(orders).sort((a, b) => Number(orders[a].createdAt) - Number(orders[b].createdAt));

        let sortedOrders = {};
        sortedOrdersKeys.forEach((item) => {
            sortedOrders[item] = orders[item];
        });

        return sortedOrders
    }

    function createOrdersAndShipmentObjectProperties(ordersAndShipment, orderId, shipmentId) {
        if (!ordersAndShipment[orderId]) {
            ordersAndShipment[orderId] = {
                shipments: [],
                createdAt: ordersWithShipments[orderId]?.createdAt
            }
        }

        if (!ordersAndShipment[orderId].shipments[shipmentId]) {
            ordersAndShipment[orderId].shipments[shipmentId] = {}
        }

        return ordersAndShipment
    }

    function partitionByShipmentType (isMulti = false) {
        let subPartition = {}

        Object.keys(ordersWithShipments).map((orderId) => {
            Object.keys(ordersWithShipments[orderId].shipments).map((shipmentId) => {
                if (isMulti) {
                    if (ordersWithShipments[orderId].shipments[shipmentId].isMulti) {
                        subPartition = createOrdersAndShipmentObjectProperties(subPartition, orderId, shipmentId)
                        subPartition[orderId].shipments[shipmentId] = ordersWithShipments[orderId].shipments[shipmentId]
                    }
                } else {
                    if (!ordersWithShipments[orderId].shipments[shipmentId].isMulti) {
                        subPartition = createOrdersAndShipmentObjectProperties(subPartition, orderId, shipmentId)
                        subPartition[orderId].shipments[shipmentId] = ordersWithShipments[orderId].shipments[shipmentId]
                    }
                }
            })
        })

        subPartition = handleFIFOSort(subPartition)

        return subPartition
    }

    const handleFilterShipmentType = (value) => {
        setShipmentTypeIndex(value)
        let orderAndShipments = {}
        Object.keys(tempOrdersWithShipments).map((orderId) => {
            Object.keys(tempOrdersWithShipments[orderId].shipments).map((shipmentId) => {
                switch (value) {
                    case 0:
                        orderAndShipments = createOrdersAndShipmentObjectProperties(orderAndShipments, orderId, shipmentId)
                        orderAndShipments[orderId].shipments[shipmentId] = tempOrdersWithShipments[orderId].shipments[shipmentId]
                        break;
                    case 1:
                        if (!ordersWithShipments[orderId].shipments[shipmentId].isMulti) {
                            orderAndShipments = createOrdersAndShipmentObjectProperties(orderAndShipments, orderId, shipmentId)
                            orderAndShipments[orderId].shipments[shipmentId] = tempOrdersWithShipments[orderId].shipments[shipmentId]
                        }
                        break;
                    case 2:
                        if (ordersWithShipments[orderId].shipments[shipmentId].isMulti) {
                            orderAndShipments = createOrdersAndShipmentObjectProperties(orderAndShipments, orderId, shipmentId)
                            orderAndShipments[orderId].shipments[shipmentId] = tempOrdersWithShipments[orderId].shipments[shipmentId]
                        }
                        break;
                    default:
                        return
                }
            })
        })
        orderAndShipments = handleFIFOSort(orderAndShipments)
        setFilteredOrdersWithShipments(orderAndShipments)
        setPackingLoading(false)
    }

    const findItemInOrders = (orders, barcode) => {
        for (const orderId of Object.keys(orders)) {
            for (const shipmentId of Object.keys(orders[orderId].shipments)) {
                const shipment = orders[orderId].shipments[shipmentId]
                if (shipment.lineItems.some((lineItem) => lineItem.eanCode === barcode)) {
                    return shipment
                }
            }
        }
    }

    const findShipmentByHive = (orders, barcode) => {
        for (const orderId of Object.keys(orders)) {
            for (const shipmentId of Object.keys(orders[orderId].shipments)) {
                const shipment = orders[orderId].shipments[shipmentId]

                if (shipment.lineItems.some((item) => item.wmsItem?.currentContainer?.codebar === barcode)) {
                    return shipment
                }
            }
        }
    }

    const openShipment = (shipment) => {
        setPackingStep({
            stepName: packingStepNames.SCAN_WORKSTATION,
            selectedShipment: shipment
        })

        if (shipment.isMulti) {
            setOpenShipmentMultiDrawer(true)
        } else {
            setOpenShipmentMonoDrawer(true)
        }
    }

    // Called when we scan an article
        async function resolveScannedArticle (barcode){
        // 1 Local, mono
        let shipment = findItemInOrders(monoOrdersWithShipments, barcode)
        if (shipment) return openShipment(shipment)

        // Database, mono
        const dbMono = await searchPackableItemsByOrder(currentInventory.id, null, barcode, false)
        if (0 < dbMono.length) return openShipment(getFormattedShipmentFromItems(dbMono))

        // Local, multi
        shipment = findItemInOrders(multiOrdersWithShipments, barcode)
        if (shipment) return openShipment(shipment)

        // Database, multi
        const dbMulti = await searchPackableItemsByOrder(currentInventory.id, null, barcode, true)
        if (0 < dbMulti.length) return openShipment(getFormattedShipmentFromItems(dbMulti))

        setEnableScan(true)
        handleToast("omniScanNotFound")
    }

    async function resolveScannedHive(barcode) {
        // 1 Local, multi
        let shipment = findShipmentByHive(multiOrdersWithShipments, barcode)
        if (shipment) return openShipment(shipment)

        // 2 Database
        const dbMulti = await searchPackableItemsByOrder(currentInventory.id, null, null, true, barcode)
        if (0 < dbMulti.length) return openShipment(getFormattedShipmentFromItems(dbMulti))

        setEnableScan(true)
        handleToast("omniScanNotFound")
    }

    function getFormattedShipmentFromItems (items) {
        const order = items[0].lineItem.currentShipment.order
        const shipment = items[0].lineItem.currentShipment
        let formattedShipment = getFormattedShipment(items[0], order, shipment)

        for (const item of items) {
            if (item.lineItem.currentShipment?.id !== shipment.id) {
                continue
            }

            formattedShipment.lineItems.push(getFormattedItem(item))
        }

        return fixShipmentIsMulti(formattedShipment)
    }

    const handleShipmentContainers = (shipment) => {
        let containers = []

        shipment.lineItems.map((item) => {
            if (containers.length === 0 || !containers.some(container => container.id === item.wmsItem.currentContainer.id)) {
                containers.push(item.wmsItem.currentContainer)
            }
        })

        return containers
    }

    const handleClickOnItem = (item) => {
        setPackingStep({
            ...packingStep,
            selectedShipment: item
        })
    }

    const handleOpenOffChartShipment = (container) => {
        setSelectedOrScannedContainer(container)
        setOpenOffChartModal(true)
    }

    const handleShipmentWaitForDrop = () => {
        finishPacking()
    }

    const handleOpenScanWorkstationModal = () => {
        if (!openAlreadyInPackingModal && handleIsPackedShipment()) {
            setOpenAlreadyInPackingModal(true)
            return
        }

        setPackingStep({
            ...packingStep,
            stepName: packingStepNames.SCAN_WORKSTATION
        })

        handleCloseAlreadyInPacking()
    }

    const handleCloseOffChartModal = () => {
        setOpenOffChartModal(false)
        setEnableScan(true)
    }

    const handleCloseAlreadyAssignedWorkstationModal = () => {
        resetScannedString()
        setOpenScanWorkstationModal(true)
        setOpenAlreadyAssignedWorkstationModal(false)
        setEnableScan(true)
    }

    const handleCloseScanWorkstationModal = () => {
        setOpenScanWorkstationModal(false)
        if (openShipmentMultiDrawer) {
            handleCloseShipmentMultiPackingDrawer()
        } else if (openShipmentMonoDrawer) {
            handleCloseShipmentMonoPackingDrawer()
        }

        if (isMultiSessionPacking) {
            setIsMultiSessionPacking(false)
        }

        setPackingStep({
            selectedShipment: {},
            stepName: packingStepNames.PEEK
        })
    }

    const handleCloseWeighShipmentModal = () => {
        resetCurrentPacking(packingStep.selectedShipment.shipmentId).then(() => {
            setPackingStep({
                ...packingStep,
                stepName: packingStepNames.RENEW
            })
            setOpenWeighShipmentModal(false)
        })

        if (isMultiSessionPacking) {
            setIsMultiSessionPacking(false)
        }
    }

    const handleCloseCCPackingModal = () => {
        resetCurrentPacking(packingStep.selectedShipment.shipmentId).then(() => {
            setPackingStep({
                ...packingStep,
                stepName: packingStepNames.RENEW
            })
            setOpenClickAndCollectPackingModal(false)
        })
    }

    const handleCloseDropZoneOrTrolleyDrawer = () => {
        setOpenDropZoneOrTrolleyDrawer(false)
        setOpenScanShippingZoneOrTrolleyModal(true)
    }

    const handleCloseShipmentMultiPackingDrawer = () => {
        if (packingStep.stepName === packingStepNames.PACK_ITEMS) {
            resetCurrentPacking(packingStep.selectedShipment.shipmentId).then(() => {
                setPackingStep({
                    ...packingStep,
                    stepName: packingStepNames.RENEW
                })
            })
        }
        setOpenShipmentMultiDrawer(false)
    }

    const handleCloseShipmentMonoPackingDrawer = () => {
        setOpenShipmentMonoDrawer(false)
        if (packingStep.stepName === packingStepNames.PACK_ITEMS) {
            setPackingStep({
                ...packingStep,
                stepName: packingStepNames.RENEW
            })
        }
    }

    const handleZoneOrTrolleySelection = (selectedObject) => {
        setOpenDropZoneOrTrolleyDrawer(false)
        setOpenScanShippingZoneOrTrolleyModal(false)
        assignShipmentToContainer(selectedObject.containerCodebar, packingStep.selectedShipment.shipmentId).then(() => {
            finishPacking()
        })
    }

    const handleShippingSlip = (isCC = false, customWeight = null) => {
        setLoading(true)

        if (!preferredPrinter?.organizationId && currentOrganization?.id) {
            // Repair the missing organizationId so the next attempt succeeds, but abandon this
            // call: setPreferredPrinter won't be reflected in this closure until the next render.
            setPreferredPrinter({...preferredPrinter, organizationId: currentOrganization.id})
            setLoading(false)
            handleToast("error")
            return
        }

        let totalWeight = 0

        for (let item of packingStep.selectedShipment.lineItems) {
            totalWeight += item.weight
        }

        let toShipObject = {
            isWMSCall: true,
            weight: packingStep.selectedShipment.shippingMethod.shippingMethodShopName !== ShippingMethods.CLICK_COLLECT ? (customWeight ?? shipmentWeigh) : totalWeight,
            preferredPrinter: preferredPrinter
        }

        if (shipmentTrackingNumber) {
            toShipObject.trackingNumber = shipmentTrackingNumber
        }

        const shipment = {
            id: packingStep.selectedShipment.shipmentId
        }

        ship(shipment, toShipObject).catch((error) => {
            handleToast("error")
        })
    }

    const handleSlipPrinted = () => {
        resetScannedString()
        handleToast("printSuccess")
        shipmentPacked(packingStep.selectedShipment.shipmentId).then(() => {
            setPackingStep({
                ...packingStep,
                stepName: packingStepNames.DROP_SHIPMENT
            })
            setOpenWeighShipmentModal(false)
        }).catch(() => {
            handleToast("error")
        })
    }

    function updatePackingStepAfterItemPacked(packingStep, setPackingStep, itemIndex) {
        let tempShipment = {...packingStep.selectedShipment}
        tempShipment.lineItems[itemIndex].itemsScanned++
        tempShipment.lineItems[itemIndex].isPacked = true
        tempShipment.lineItems[itemIndex].wmsItem.status = WmsItemsStatus.PACKED
        setPackingStep({
            ...packingStep,
            selectedShipment: tempShipment
        })
    }

    function getItemIndex (eanCode) {
        return packingStep.selectedShipment.lineItems.findIndex(item =>
            item.eanCode === eanCode &&
            (
                item.wmsItem.status === WmsItemsStatus.PACKED ||
                item.wmsItem.status === WmsItemsStatus.PACKING ||
                item.wmsItem.status === WmsItemsStatus.READY_TO_BE_PACKED
            ) && !item.isPacked && !item.isCancelled
        )
    }

    const handlePackItem = (eanCode) => {
        const itemIndex = getItemIndex(eanCode)

        if (itemIndex >= 0) {
            setPackingLoading(true)
            const wmsItem = packingStep.selectedShipment.lineItems[itemIndex].wmsItem
            const wmsItemStatus = wmsItem.status

            getWmsItemToBeCancelledStatus(wmsItem.id).then((response) => {
                const isToBeCancelledItem = response.toBeCancelled

                if (isToBeCancelledItem && getWmsItemsCancellableStatus().includes(wmsItemStatus)) {
                    setEnableScan(false)
                    setToBeCancelledItem({...wmsItem, toBeCancelled: isToBeCancelledItem})
                    setOpenToBeCancelledModal(true)
                    setPackingLoading(false)
                    return
                }

                return packShipmentItem(wmsItem.id).then(() => {
                    updatePackingStepAfterItemPacked(packingStep, setPackingStep, itemIndex)
                }).finally(() => {
                    setPackingLoading(false)
                })
            }).catch(() => {
                setPackingLoading(false)
            })
        } else {
            setEnableScan(true)
            handleToast("wrongItemScanned")
        }
    }

    const handleAllItemAreCancelled = () => {
        handleToast("allCancelled")
        setPackingStep({
            ...packingStep,
            stepName: packingStepNames.RENEW
        })
    }

    const handleForceAssignWorkstation = () => {
        patchWMSContainerMemberWithCodebar(alreadyTakenPackingStationContainer.codebar, currentMember).then(() => {
            handleWorkstationClaimed(alreadyTakenPackingStationContainer, alreadyTakenPackingStationContainer.computerId)
        })
    }

    const handlePrintClickAndCollectDocuments = () => {
        handleShippingSlip(true)
    }

    const handleManuallySelectShippingZoneOrTolley = () => {
        setOpenDropZoneOrTrolleyDrawer(true)
        setOpenScanShippingZoneOrTrolleyModal(false)
        if (packingStep.selectedShipment.isMulti) {
            setOpenShipmentMultiDrawer(false)
        } else {
            setOpenShipmentMonoDrawer(false)
        }
    }

    const handleBeginShipmentWeigh = () => {
        if (!packingStep.selectedShipment.isMulti && !packingStep.selectedShipment.isSpecialOrder) {
            // lineItems[0] is not reliable here: a mono shipment can carry a second, to-be-cancelled
            // WMSItem (see ShipmentMonoPackingDrawer), which must never be packed/shipped.
            const itemToPack = packingStep.selectedShipment.lineItems.find((item) => !item.isCancelled)
            if (itemToPack) {
                packShipmentItem(itemToPack.wmsItem.id)
            }
        }

        if (packingStep.selectedShipment.isSpecialOrder) {
            specialOrderShipmentIsPackInWMS(packingStep.selectedShipment.id).then(() => {
                packingStep.selectedShipment.isPackedInWMS = true
            })
        }

        setPackingStep({
            ...packingStep,
            stepName: packingStepNames.WEIGH_SHIPMENT
        })
    }

    const handleWorkstationClaimed = (workstation, computerId) => {
        setPackingStationComputerId(computerId)
        setCurrentWorkstation(workstation)
        setPreferredPackingStation(workstation)
        // The packing station is the source of truth for the printer: always sync preferredPrinter from it, never the other way around.
        setPreferredPrinter({...preferredPrinter, labelPrinterId: workstation.labelPrinterId, organizationId: currentOrganization?.id})
        setOpenScanWorkstationModal(false)
        setOpenAlreadyAssignedWorkstationModal(false)

        if (packingStep.selectedShipment.isSpecialOrder === true) {
            handleBeginShipmentWeigh();
        } else if (packingStep.stepName === packingStepNames.SCAN_WORKSTATION){
            setPackingStep(
                {
                    ...packingStep,
                    stepName: packingStepNames.PACK_ITEMS
                }
            )
            handleToast("pack_item", !packingStep.selectedShipment.isMulti)
        } else if (packingStep.stepName === packingStepNames.PEEK) {
            // No stepName transition happens here, so nothing else re-enables scanning afterwards.
            setEnableScan(true)
            handleToast("workstationScanned", false)
        }

        resetScannedString()
    }

    const handleAlreadyTakenWorkstation = (container) => {
        setAlreadyTakenPackingStationContainer(container)
        setOpenAlreadyAssignedWorkstationModal(true)
    }

    const handleToast = (type, isTop = false) => {
        setToastType(type)
        setOpenToast(true)
        setToastIsTop(isTop)
    }

    const handleClosePackingActionDrawer = () => {
        setOpenPackingActionDrawer(false)
    }

    const finishPacking = () => {
        if (isPartialExpedition) {
            handleToast("partialPackingFinished")
        } else {
            handleToast("articleDropSuccess")
        }

        setPackingStep({
            ...packingStep,
            stepName: packingStepNames.RENEW
        })
    }

    function formatShipmentFromSpecialOrderForPacking(order, shipmentIndex) {
        const shipment = order.shipments[shipmentIndex];

        shipment.isMulti = shipment.multi;
        shipment.shipmentId = shipment.id
        shipment.isSpecialOrder = true;
        shipment.orderId = order.id;

        if (shipment.shippingMethod.additionalData?.clickAndCollectPoint !== currentInventory.code) {
            shipment.isCCInternalWMSShip = true
        }

        return order.shipments[shipmentIndex];
    }

    const handleValidAlreadyInPacking = () => {
        handleOpenScanWorkstationModal()
    }

    const handleCloseAlreadyInPacking = () => {
        setOpenAlreadyInPackingModal(false)
    }

    const handleIsPackedShipment = (shipmentItem = null) => {
        const shipment = shipmentItem ?? packingStep.selectedShipment
        const lineItems = shipment.lineItems
        let wmsItems = []

        lineItems.forEach(item => {
            wmsItems.push(item.wmsItem)
        })

        // If shipment has a container, its status is ready_to_be_shipped and it is not a special order shipment.
        const isPackedShipment = !!shipment.container

        let areLineItemsToShip = lineItems.every(item => item.status === LineItemStatus.TO_SHIP)

        const areWmsItemsPacked = wmsItems.every(
            item =>
                item.status === WmsItemsStatus.PACKED ||
                item.status === WmsItemsStatus.PACKING
        )

        if (isPackedShipment || areLineItemsToShip || areWmsItemsPacked) {
            return true
        }

        return false
    }

    const handlePackingAction = (action = "") => {
        switch (action) {
            case "specialOrder":
                setOpenSpecialOrderDrawer(true)
                break;
            case "packingStation":
                resetScannedString()
                setEnableScan(true)
                setOpenScanWorkstationModal(true)
                break;
            case "multiExpSession":
                resetScannedString()
                setEnableScan(true)
                setOpenMultiExpSessionStartModal(true)
                break;
            default:
                break;
        }

        setOpenPackingActionDrawer(false)
    }

    const getFilteredOrderByIndex = () => {
        return filteredOrdersWithShipments[Object.keys(filteredOrdersWithShipments)[multiExpSessionOrderIndex.current]]
    }

    const getFilteredOrderShipmentsByIndex = () => {
        return getFilteredOrderByIndex().shipments[Object.keys(getFilteredOrderByIndex().shipments)[multiExpSessionShipmentIndex.current]]
    }

    const handleCloseMultiExpSessionStartModal = () => {
        setOpenMultiExpSessionStartModal(false)
    }

    const handleMultiExpSessionShipmentTypeFilter = (value) => {
        handleFilterShipmentType(value)
        setIsMultiSessionPacking(true)
        setOpenMultiExpSessionStartModal(false)
    }

    const handleMultiExpeditionSessionStart = () => {
        setPackingStep({
            stepName: packingStepNames.PEEK,
            selectedShipment: getFilteredOrderShipmentsByIndex()
        })

        setOpenScanWorkstationModal(false)
        setOpenAlreadyInPackingModal(false)
        setOpenClickAndCollectPackingModal(false)
        setOpenWeighShipmentModal(false)
    }

    const nextShipment = () => {
        const orderShipmentLastIndex = Object.keys(getFilteredOrderByIndex().shipments).length - 1
        const orderLastIndex = Object.keys(filteredOrdersWithShipments).length - 1

        shipmentSplitNewShipment.current = null

        if (orderLastIndex === multiExpSessionOrderIndex.current) {
            setPackingStep({
                ...packingStep,
                stepName: packingStepNames.RENEW
            })
            return
        }

        if (orderShipmentLastIndex === multiExpSessionShipmentIndex.current) {
            multiExpSessionOrderIndex.current += 1
            multiExpSessionShipmentIndex.current = 0
        } else {
            multiExpSessionShipmentIndex.current += 1
        }

        setLoading(false)
        setPackingLoading(false)
        handleMultiExpeditionSessionStart()
    }

    const handleForceStopMultiPackingSession = () => {
        if (isMultiSessionPacking) {
            setIsMultiSessionPacking(false)
        }

        setOpenScanWorkstationModal(false)
        setOpenWeighShipmentModal(false)
        setOpenAlreadyInPackingModal(false)
    }

    const handleContinueSplitShipment = () => {
        const order = filteredOrdersWithShipments[shipmentSplitNewShipment.current.order.id]
        if (!order) {
            return false
        }

        const shipmentToPack = Object.values(order.shipments).find((shipment) => shipment.shipmentId === shipmentSplitNewShipment.current.id)


        if (!shipmentToPack) {
            return false
        }

        if (false === shipmentToPack.isMulti) {
            resetCurrentPacking(shipmentToPack.shipmentId).then(() => {
                setPackingStep({
                    ...packingStep,
                    selectedShipment: shipmentToPack
                })
            })
        } else {
            setPackingStep({
                ...packingStep,
                selectedShipment: shipmentToPack
            })
        }

        return true
    }

    // -----------------------USE-EFFECT--------------------------

    useEffect(() => {
        switch (packingStep.stepName) {
            case packingStepNames.PEEK:
                setEnableScan(true)
                if (packingStep.selectedShipment && Object.keys(packingStep.selectedShipment).length > 0) {
                    if (packingStep.selectedShipment.isMulti && !openScanShippingZoneOrTrolleyModal) {
                        setOpenShipmentMultiDrawer(true)
                    } else {
                        setOpenShipmentMonoDrawer(true)
                    }
                } else if (packingStep.selectedShipment && Object.keys(packingStep.selectedShipment).length === 0 && currentInventory) {
                    handlePackingStart()
                }
                break;
            case packingStepNames.SCAN_WORKSTATION:
                resetScannedString()
                if (openShipmentMonoDrawer) {
                    // If shipmentSplit isn't available with monoShipment.
                    shipmentSplitNewShipment.current = null
                    setIsPartialExpedition(false)
                }
                if (!currentOrganization?.forcePackingStationScan) {
                    if (currentWorkstation && packingStationComputerId) {
                        setOpenToast(true)
                        setToastType("noWorkstationScanBeginPacking")
                        if (packingStep.selectedShipment.isSpecialOrder === true) {
                            handleBeginShipmentWeigh();
                        } else {
                            setPackingStep({
                                ...packingStep,
                                stepName: packingStepNames.PACK_ITEMS
                            })
                            handleToast("pack_item", !packingStep.selectedShipment.isMulti)
                        }
                    } else {
                        setEnableScan(true)
                        setOpenScanWorkstationModal(true)
                    }
                } else {
                    setEnableScan(true)
                    setOpenScanWorkstationModal(true)
                }
                break;
            case packingStepNames.PACK_ITEMS:
                setEnableScan(true)
                setOpenScanWorkstationModal(false)
                setOpenAlreadyAssignedWorkstationModal(false)
                break;
            case packingStepNames.WEIGH_SHIPMENT:
                assignShipmentToContainer(currentWorkstation.codebar, packingStep.selectedShipment.shipmentId).then(() => {
                    const shippingMethod = packingStep.selectedShipment.shippingMethod;
                    if (shippingMethod.shippingMethodShopName === ShippingMethods.CLICK_COLLECT || shippingMethod.discr === ShippingMethodsDiscr.CLICK_COLLECT || (shippingMethod.discr === ShippingMethodsDiscr.KN && shippingMethod.shippingMethodShopName === KNCarrierType.NAVETTE)) {
                        setOpenClickAndCollectPackingModal(true)
                    } else {
                        setOpenWeighShipmentModal(true)
                    }
                })
                break;
            case packingStepNames.DROP_SHIPMENT:
                setEnableScan(true)
                setOpenWeighShipmentModal(false)
                setOpenClickAndCollectPackingModal(false)
                setOpenScanShippingZoneOrTrolleyModal(true)
                setLoading(false)
                break;
            case packingStepNames.RENEW:
                setSearchString(null)
                setOpenShipmentMonoDrawer(false)
                setOpenShipmentMultiDrawer(false)
                setOpenBeginPackingModal(false)
                setOpenScanWorkstationModal(false)
                setOpenScanShippingZoneOrTrolleyModal(false)
                setOpenAlreadyAssignedWorkstationModal(false)
                setOpenClickAndCollectPackingModal(false)
                setOpenOffChartModal(false)
                setOpenProductProblemDrawer({
                    ...openProductProblemDrawer,
                    isOpen: false
                })
                setShipmentWeigh(null)
                setShipmentTrackingNumber(null)
                if (currentOrganization?.forcePackingStationScan) {
                    setPackingStationComputerId(null)
                    setCurrentWorkstation(null)
                    setPreferredPackingStation({})
                }
                setLoading(false)
                resetScannedString()
                setTempOrdersWithShipments({})
                setFilteredOrdersWithShipments(null)
                setPackingStep({
                    stepName: packingStepNames.PEEK,
                    selectedShipment: {}
                })
                setIsPartialExpedition(false)
                multiExpSessionOrderIndex.current = 0
                multiExpSessionShipmentIndex.current = 0
                handlePackingStart()
                break;
            default:
                return
        }
    }, [packingStep]);

    useEffect(() => {
        // Cancel any pending remote search
        if (searchDebounceRef.current) {
            clearTimeout(searchDebounceRef.current)
            searchDebounceRef.current = null
        }
        setIsSearchingRemote(false)

        let searchedOrdersAndShipments = {}
        Object.keys(ordersWithShipments).map((orderId) => {
            Object.keys(ordersWithShipments[orderId].shipments).map((shipmentId) => {
                if (ordersWithShipments[orderId].shipments[shipmentId].orderNumber.includes(searchString)) {
                    searchedOrdersAndShipments = createOrdersAndShipmentObjectProperties(searchedOrdersAndShipments, orderId, shipmentId)
                    searchedOrdersAndShipments[orderId].shipments[shipmentId] = ordersWithShipments[orderId].shipments[shipmentId]
                }
            })
        })

        if (0 < Object.keys(searchedOrdersAndShipments).length) {
            handleMonoAndMultiCount(searchedOrdersAndShipments)
            setTempOrdersWithShipments(searchedOrdersAndShipments)
        }

        // If the local search found nothing, trigger a remote search after 1s
        if (searchString && Object.keys(searchedOrdersAndShipments).length === 0) {
            searchDebounceRef.current = setTimeout(() => {
                setIsSearchingRemote(true)
                searchPackableItemsByOrder(currentInventory.id, searchString)
                    .then((results) => {
                        if (0 < results.length) {
                            const firstItem = results[0]
                            const order = firstItem.lineItem.currentShipment.order
                            const shipment = firstItem.lineItem.currentShipment
                            let formattedShipment = getFormattedShipment(firstItem, order, shipment)
                            for (const item of results) {
                                formattedShipment.lineItems.push(getFormattedItem(item))
                            }
                            setPackingStep({
                                stepName: packingStepNames.SCAN_WORKSTATION,
                                selectedShipment: formattedShipment
                            })
                            if (formattedShipment.isMulti) {
                                setOpenShipmentMultiDrawer(true)
                            } else {
                                setOpenShipmentMonoDrawer(true)
                            }
                        } else {
                            handleToast("orderNotFound")
                        }
                    })
                    .finally(() => {
                        setIsSearchingRemote(false)
                    })
            }, 1000)
        }

        return () => {
            if (searchDebounceRef.current) {
                clearTimeout(searchDebounceRef.current)
            }
        }
    }, [searchString]);

    useEffect(() => {
        if(Object.keys(tempOrdersWithShipments).length > 0) {
            handleFilterShipmentType(shipmentTypeIndex)
        }
    }, [tempOrdersWithShipments])

    // Scan useEffect
    useEffect(() => {
        if (scannedString !== "" && (0 < Object.keys(ordersWithShipments).length && 0 < Object.keys(tempOrdersWithShipments).length)) {
            setEnableScan(false)
            if (
                packingStep.stepName === packingStepNames.PEEK &&
                !openScanShippingZoneOrTrolleyModal &&
                !openScanWorkstationModal &&
                !openWeighShipmentModal &&
                !openAlreadyAssignedWorkstationModal &&
                !openBeginPackingModal
            ) {
                launchOmniScan(scannedString, currentInventory.id, {
                    [WMSOmniScanContextKeys.ITEM]: [
                        WmsItemsStatus.READY_TO_BE_PACKED,
                        WmsItemsStatus.PACKED
                    ],
                    [WMSOmniScanContextKeys.CONTAINER]: [WmsContainerType.HIVE],
                }).then((response) => {
                    if (response.length > 1) {
                        // Multiple entities detected need modal to check which is needed
                        // TODO: WMS V2 Omniscan add a global modal to select witch entity was scanned
                    }
                    if (response.length === 1) {
                        if (
                            response[0].entityType === WMSOmniScanReturnType.ITEM &&
                            !openShipmentMultiDrawer
                        ) {
                            resolveScannedArticle(scannedString)
                        }

                        if (
                            // No need to check for the container type as it is already filtered down to HIVE by the OmniScan.
                            response[0].entityType === WMSOmniScanReturnType.CONTAINER &&
                            !openShipmentMultiDrawer
                        ) {
                            resolveScannedHive(scannedString)
                        }
                    }

                    if (response.length === 0) {
                        setPackingStep({
                                stepName: packingStepNames.PEEK
                        })
                        handleToast("omniScanNotFound")
                    }
                    resetScannedString()
                })
            }

            if (
                packingStep.selectedShipment &&
                packingStep.stepName === packingStepNames.PACK_ITEMS &&
                (openShipmentMultiDrawer || openShipmentMonoDrawer) &&
                !openScanShippingZoneOrTrolleyModal &&
                !openScanWorkstationModal &&
                !openWeighShipmentModal &&
                !openAlreadyAssignedWorkstationModal &&
                !openBeginPackingModal
            ) {
                let lineItemsEanCodes = packingStep.selectedShipment.lineItems.map((lineItem) => {
                    return lineItem.eanCode
                })

                if (lineItemsEanCodes.includes(scannedString)) {
                    handlePackItem(scannedString)
                } else {
                    setEnableScan(true)
                    handleToast("wrongItemScanned")
                }
            }
        }
    }, [scannedString]);

    useEffect(() => {
        if (currentInventory) {
            handlePackingStart()
        }
    }, [currentInventory]);

    useEffect(() => {
        if (!currentInventory || !currentMember?.wmsContainers) {
            return
        }

        const memberPackingStation = currentMember.wmsContainers.filter(
            (container) => container.type === WmsContainerType.PACKING_STATION && container.inventory === currentInventory.id
        ).shift()

        if (!memberPackingStation) {
            return
        }

        getWMSContainerWithCodeBar(memberPackingStation.codebar).then((station) => {
            setPreferredPackingStation(station)
            setPreferredPrinter({...preferredPrinter, labelPrinterId: station.labelPrinterId, organizationId: currentOrganization?.id})
        })
    }, [currentInventory, currentMember]);

    useEffect(() => {
        if (filteredOrdersWithShipments && packingStepNames.PEEK === packingStep.stepName && null !== shipmentSplitNewShipment.current) {
            // This for the only case where we are reloading the packing while in a multiExpeditionSession and after splitting the previous shipment, leaving the nextShipment as a mono shipment.
            if (handleContinueSplitShipment()) {
                return
            }
        }

        if (filteredOrdersWithShipments && packingStepNames.PEEK === packingStep.stepName && isMultiSessionPacking) {
            if (Object.keys(filteredOrdersWithShipments).length === 0) {
                setIsMultiSessionPacking(false)
                return
            }
            handleMultiExpeditionSessionStart()
            return
        }
    }, [isMultiSessionPacking, packingStep.stepName, filteredOrdersWithShipments]);

    useEffect(() => {
        if (0 < Object.keys(preferredPackingStation).length) {
            setPackingStationComputerId(preferredPackingStation.computerId)
            setCurrentWorkstation(preferredPackingStation)
        }
    }, [preferredPackingStation]);

    useEffect(() => {
        list("status=reserved&transition=cancel&wms=true").then(response => {
            setCancellationReasons(response)
        })
    }, []);

    return (
        <PackingContext.Provider value={{
            cancellationReasons,
            openProductProblemDrawer,
            setOpenProductProblemDrawer,
            handleAllItemAreCancelled,
            handlePackItem,
            packingLoading,
            setPackingLoading,
            isMultiSessionPacking,
            setIsMultiSessionPacking,
            multiExpSessionOrderIndex,
            multiExpSessionShipmentIndex,
            nextShipment,
            handleForceStopMultiPackingSession,
            shipmentSplitNewShipment,
            isPartialExpedition,
            setIsPartialExpedition,
            shipmentTrackingNumber,
            setShipmentTrackingNumber,
            packingStep,
            setPackingStep,
            currentWorkstation,
            getItemIndex,
            openToBeCancelledModal,
            setOpenToBeCancelledModal,
            toBeCancelledItem,
            setToBeCancelledItem
        }}>
        <Grid container direction={"column"}>

            {/* All modals are here */}
            <>
                {/* Scan Workstation modal */}
                {openScanWorkstationModal && (
                    <ScanWorkstationModal
                        open={openScanWorkstationModal}
                        handleClose={handleCloseScanWorkstationModal}
                        handleWorkstationClaimed={handleWorkstationClaimed}
                        handleAlreadyTakenWorkstation={handleAlreadyTakenWorkstation}
                    />
                )}

                {openAlreadyInPackingModal && (
                    <AlreadyInPackingModal
                        open={openAlreadyInPackingModal}
                        handleClose={handleCloseAlreadyInPacking}
                        handleIsValid={handleValidAlreadyInPacking}
                    />
                )}

                {/* Already assigned workstation modal */}
                {openAlreadyAssignedWorkstationModal && alreadyTakenPackingStationContainer && (
                    <AlreadyAssignedWorkstation
                        open={openAlreadyAssignedWorkstationModal}
                        handleClose={handleCloseAlreadyAssignedWorkstationModal}
                        handleValid={handleForceAssignWorkstation}
                    />
                )}

                {/* Weigh shipment modal */}
                {openWeighShipmentModal && (
                    <WeighShipmentModal
                        open={openWeighShipmentModal}
                        handleClose={handleCloseWeighShipmentModal}
                        handleValidation={handleShippingSlip}
                        isLoading={loading}
                        setIsLoading={setLoading}
                        shipmentWeigh={shipmentWeigh}
                        setShipmentWeigh={setShipmentWeigh}
                        packingStationComputerId={packingStationComputerId}
                        handleToast={handleToast}
                        packingStep={packingStep}
                        validPrint={handleSlipPrinted}
                    />
                )}

                {/* Scan zone or trolley */}
                {openScanShippingZoneOrTrolleyModal && packingStep.selectedShipment && (
                    <ScanShippingZoneOrTrolleyModal
                        open={openScanShippingZoneOrTrolleyModal}
                        handleClose={handleShipmentWaitForDrop}
                        handleManualSelection={handleManuallySelectShippingZoneOrTolley}
                        handleSlipPrint={handleShippingSlip}
                        isLoading={loading}
                        packingStep={packingStep}
                        handleOffChartShipment={handleOpenOffChartShipment}
                        handleShipmentWaitForDrop={handleShipmentWaitForDrop}
                        finishPacking={finishPacking}
                        isCC={packingStep.selectedShipment.shippingMethod.discr === ShippingMethodsDiscr.CLICK_COLLECT || packingStep.selectedShipment.shippingMethod.shippingMethodShopName === KNCarrierType.NAVETTE}
                    />
                )}

                {/* Click and collect modal */}
                {openClickAndCollectPackingModal && (
                    <ClickAndCollectPackingModal
                        open={openClickAndCollectPackingModal}
                        handleClose={handleCloseCCPackingModal}
                        handlePrintDocuments={handlePrintClickAndCollectDocuments}
                        packingStep={packingStep}
                        isLoading={loading}
                        setIsLoading={setLoading}
                        validPrint={handleSlipPrinted}
                    />
                )}

                {/* Off chart article modal */}
                <OffChartModal
                    open={openOffChartModal}
                    handleClose={handleCloseOffChartModal}
                    selectedContainer={selectedOrScannedContainer}
                    finishPacking={finishPacking}
                    shipment={packingStep.selectedShipment}
                />
            </>

            {openMultiExpSessionStartModal && (
                <MultiExpSessionStartModal
                    open={openMultiExpSessionStartModal}
                    handleClose={handleCloseMultiExpSessionStartModal}
                    handleFilterValue={(value) => handleMultiExpSessionShipmentTypeFilter(value)}
                    monoShipmentCount={monoShipmentCount}
                    multiShipmentCount={multiShipmentCount}
                />
            )}

            {/* Drop zone or trolley manual selection bottom drawer */}
            {openDropZoneOrTrolleyDrawer && packingStep.selectedShipment && (
                <DropZoneOrTrolleyDrawer
                    open={openDropZoneOrTrolleyDrawer}
                    handleClose={handleCloseDropZoneOrTrolleyDrawer}
                    handleZoneOrTrolleySelection={handleZoneOrTrolleySelection}
                    currentShipment={packingStep.selectedShipment}
                    isCCInternalWMSShip={packingStep.selectedShipment.isCCInternalWMSShip}
                    isCC={packingStep.selectedShipment.shippingMethod.discr === ShippingMethodsDiscr.CLICK_COLLECT || packingStep.selectedShipment.shippingMethod.shippingMethodShopName === KNCarrierType.NAVETTE}
                />
            )}

            {openShipmentMultiDrawer === true && packingStep.selectedShipment && (packingStep.selectedShipment.isMulti === true) && (
                <ShipmentMultiPacking
                    open={openShipmentMultiDrawer}
                    handleClose={handleCloseShipmentMultiPackingDrawer}
                    beginPacking={handleOpenScanWorkstationModal}
                    packingStep={packingStep}
                    beginShipmentWeigh={handleBeginShipmentWeigh}
                    setPackingStep={setPackingStep}
                />
            )}

            {openShipmentMonoDrawer === true && packingStep.selectedShipment && (packingStep.selectedShipment.isMulti === false) && (
                <ShipmentMonoPacking
                    open={openShipmentMonoDrawer}
                    handleClose={handleCloseShipmentMonoPackingDrawer}
                    beginPacking={handleOpenScanWorkstationModal}
                    packingStep={packingStep}
                    beginShipmentWeigh={handleBeginShipmentWeigh}
                />
            )}

            {openSpecialOrderDrawer === true && (
                <SpecialOrderDrawer
                    isOpen={openSpecialOrderDrawer}
                    onClose={() => setOpenSpecialOrderDrawer(false)}
                    currentInventory={currentInventory}
                    onClickSelectedOrder={(selectedSpecialOrder, shipmentIndex) => {
                        setPackingStep({
                            selectedShipment: formatShipmentFromSpecialOrderForPacking(selectedSpecialOrder, shipmentIndex),
                            stepName: packingStepNames.SCAN_WORKSTATION,
                        })
                    }}
                />
            )}

            {openPackingActionDrawer && (
                <PackingActionDrawer
                    open={openPackingActionDrawer}
                    onClose={() => handleClosePackingActionDrawer()}
                    selectedAction={(action) => handlePackingAction(action)}
                />
            )}

            {openToast && (
                <PackingToast
                    open={openToast}
                    handleClose={() => setOpenToast(false)}
                    type={toastType}
                    isTop={toastIsTop}
                    searchString={searchString}
                />
            )}

            <Card>
                <CardContent>
                    <Grid container direction={"column"} gap={"20px"}>
                        <ToggleNavigation
                            fullWidth={true}
                            value={shipmentTypeIndex}
                            onChange={(value) => handleFilterShipmentType(value)}
                            autoMargin
                        >
                            {/* Value is 0 and is for no filter */}
                            <Toggle
                                fullWidth={true}
                                label={<FormattedMessage id={"wms.packing.filterToggle.label.all"}/>}
                                count={monoShipmentCount + multiShipmentCount}
                                autoHeight
                            />

                            {/* Value is 1 and is for mono filter */}
                            <Toggle
                                fullWidth={true}
                                label={<FormattedMessage id={"wms.packing.filterToggle.label.mono"}/>}
                                count={monoShipmentCount}
                                autoHeight
                            />

                            {/* Value is 2 and is for multi filter */}
                            <Toggle
                                fullWidth={true}
                                label={<FormattedMessage id={"wms.packing.filterToggle.label.multi"}/>}
                                count={multiShipmentCount}
                                autoHeight
                            />
                        </ToggleNavigation>

                        <Grid container direction={"row"} flexWrap={"nowrap"} alignItems={"center"} justifyContent={"space-between"}>
                            <Grid item sx={{flex: 1, minWidth: 0}}>
                                {/* SearchBar search inside the filtered list */}
                                <SearchBar
                                    customPlaceholder={"wms.packing.searchBar.placeholder"}
                                    onChange={(value) => setSearchString(value)}
                                />
                            </Grid>

                            {isSearchingRemote && (
                                <Grid item sx={{paddingLeft: '8px', display: 'flex', alignItems: 'center'}}>
                                    <BeatLoaderRegular loading={true} size={8} />
                                </Grid>
                            )}

                            <PackingActionButton onClick={() => {setOpenPackingActionDrawer(true)}} customMargin={"8px"}/>
                        </Grid>

                    </Grid>
                </CardContent>
            </Card>

            <Card>
                <CardContent>
                    <Grid container direction={"column"}>
                        {loading && 0 === Object.keys(filteredOrdersWithShipments).length && (
                            <Grid item sx={{margin: "auto"}}>
                                <BeatLoaderRegular loading={true} size={15} />
                            </Grid>
                        )}

                        {filteredOrdersWithShipments && Object.keys(filteredOrdersWithShipments).map((orderId) => {
                            if (undefined === ordersWithShipments[orderId]) {
                                return
                            }
                            const shipmentsIdArray = Object.keys(ordersWithShipments[orderId].shipments)
                            const shipmentsNumber = shipmentsIdArray.length

                            return Object.keys(filteredOrdersWithShipments[orderId].shipments).map((shipmentId, index) => {
                                const shipment = filteredOrdersWithShipments[orderId].shipments[shipmentId]
                                const isMulti = shipment.isMulti
                                // A mono shipment can hold a second, to-be-cancelled WMSItem alongside
                                // the real one: preview the real item, not whichever landed at index 0.
                                const primaryLineItem = isMulti
                                    ? null
                                    : (shipment.lineItems.find((item) => !item.wmsItem.toBeCancelled) ?? shipment.lineItems[0])

                                let isPackedShipment = false

                                if (handleIsPackedShipment(shipment)) {
                                    isPackedShipment = true
                                }

                                return (
                                    <div onClick={() => handleClickOnItem(shipment)}>
                                        <WmsItemWithOrder
                                            key={shipmentId}
                                            thumbnailSource={isMulti ? '#' : primaryLineItem.pictures[0]}
                                            thumbnailAlt={`${shipment.lineItems.name} thumbnail`}
                                            icon={shipment.shippingMethod.carrierIcon}
                                            iconAlt={`${shipment.shippingMethod.name} icon`}
                                            numOrder={`#${shipment.orderNumber}`}
                                            orderCreatedAt={shipment.orderCreatedAt}
                                            description={
                                                isMulti ?
                                                    <span>{shipment.lineItems.length} <FormattedMessage id={'wms.packing.articles'}/></span> :
                                                    <span>{primaryLineItem.name}</span>
                                            }
                                            isMulti={isMulti}
                                            badges={handleShipmentContainers(shipment)}
                                            multiShipment={shipmentsNumber > 1}
                                            shipmentCount={<span>{index + 1}/{shipmentsNumber}</span>} // Dans le cas d'une commande multi avec plusieurs shipments.
                                            isPackedShipment={isPackedShipment}
                                        />
                                    </div>
                                )
                            })
                        })}
                    </Grid>
                </CardContent>
            </Card>
        </Grid>
        </PackingContext.Provider>
    );
}

export default PackingOrderList;
